import { render, staticRenderFns } from "./service-container-wrapper.vue?vue&type=template&id=69847f10&scoped=true&"
import script from "./service-container-wrapper.vue?vue&type=script&lang=ts&"
export * from "./service-container-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./service-container-wrapper.vue?vue&type=style&index=0&id=69847f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69847f10",
  null
  
)

export default component.exports